import { render, staticRenderFns } from "./equipmentRecord.vue?vue&type=template&id=b7a8bb7e"
import script from "./equipmentRecord.vue?vue&type=script&lang=js"
export * from "./equipmentRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7a8bb7e')) {
      api.createRecord('b7a8bb7e', component.options)
    } else {
      api.reload('b7a8bb7e', component.options)
    }
    module.hot.accept("./equipmentRecord.vue?vue&type=template&id=b7a8bb7e", function () {
      api.rerender('b7a8bb7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/mim/inspection/equipmentRecord.vue"
export default component.exports